import { Alert, Button, EmptyState } from "@assetwatch/ui";

export function PageViewEmptyState({
  hasActiveFilters,
  onClearFilters,
}: {
  hasActiveFilters: boolean;
  onClearFilters?: () => void;
}) {
  return hasActiveFilters ? (
    <EmptyState
      actions={
        onClearFilters ? (
          <Button onClick={onClearFilters} size="sm" variant="outline">
            Clear Filters
          </Button>
        ) : undefined
      }
      description="Adjust your search or filters and try again."
      icon="circle-check-regular"
      title="No requests match your filters"
    />
  ) : (
    <EmptyState
      description="Requests submitted to this facility will appear here."
      icon="circle-check-regular"
      title="No work requests"
    />
  );
}

export function PageViewLoadFailure({ onRetry }: { onRetry: () => void }) {
  return (
    <Alert
      action={
        <Button onClick={onRetry} size="sm" variant="outline">
          Retry
        </Button>
      }
      title="Unable to load this view."
      tone="negative"
    />
  );
}

export function PageViewAccessDenied() {
  return <Alert title="You do not have access to this view." tone="warning" />;
}

export function PageViewUnavailable() {
  return (
    <Alert
      title="This request is unavailable. Select a request from the list to continue."
      tone="warning"
    />
  );
}
